export default __webpack_public_path__ + "51d9cca61319a5ff0349a652a7c89a49.png";